import { useCallback, useRef } from 'react'

export function useFreshdeskWidget() {
  // Use a ref to ensure we don't attach event listeners multiple times
  const isInitialized = useRef(false)

  const openWidget = useCallback(() => {
    const widgetId = 1130000000404

    // 1. Define settings
    window.fwSettings = { widget_id: widgetId }

    // 2. SETUP THE QUEUE SHIM
    // If the widget isn't loaded yet, create a placeholder function that
    // pushes commands to a queue. The real script will process this queue when it loads.
    if (typeof window.FreshworksWidget !== 'function') {
      window.FreshworksWidget = function (...args) {
        window.FreshworksWidget.q.push(args)
      }
      window.FreshworksWidget.q = []
    }

    // 3. ISSUE COMMANDS IMMEDIATELY
    // Because of the shim above, we don't need to wait for 'onload'.
    // These commands sit in the queue and fire the moment the widget is ready.
    window.FreshworksWidget('hide', 'launcher')
    window.FreshworksWidget('open')

    // 4. Attach Close Listener (Once only)
    if (!isInitialized.current) {
      window.FreshworksWidget('on', 'user:action:close', () => {
        window.FreshworksWidget('hide', 'launcher')
      })
      isInitialized.current = true
    }

    // 5. Load the script (if missing)
    if (!document.getElementById('freshdesk-widget-script')) {
      const script = document.createElement('script')
      script.id = 'freshdesk-widget-script'
      script.src = `https://ind-widget.freshworks.com/widgets/${widgetId}.js`
      script.async = true
      script.defer = true
      document.body.appendChild(script)
    }
  }, [])

  return { openWidget }
}
